import { createSelector } from '@reduxjs/toolkit';

import { sortBy } from '@paragon/utilities';

import { RootState } from '../store';

export const getSortedViews = createSelector(
  (state: RootState) => state.views.savedViews,
  (jobFilters) => sortBy(jobFilters, (filter) => filter.name.toLowerCase()),
);
